module.exports = __webpack_public_path__ + "0c54448060a12e193b0caefb25086299.pdf";